import {StoreType} from '../../../types/sharedTypes';

export const containerShipmentParamsSelector = (state: StoreType) => {
  return state.containerShipmentReducer.params;
}

export const allContainerShipmentSelector = (state: StoreType) => {
  return state.containerShipmentReducer.containerShipmentResult;
}

export const allContainersInProcess= (state: StoreType) => {
  return state.containerShipmentReducer.containersInProcess;
}

export const containerShipmentScheduleSelector = (state: StoreType) => {
  return state.containerShipmentReducer.schedule;
}

export const containerShipmentByDownloadDateSelector = (state: StoreType) => {
  return state.containerShipmentReducer.containerShipmentResultByDownloadDate;
}
